import { Toastr } from 'components/global/Toastr'
import { handleResponseErr } from 'utils/apiHelperUtils'
import { handlePayrunClasses } from 'components/global/helperReducer'
import * as actions from './actions'

export const initialState = {
  fetching: false,
  additions_deduction_info: {
    header: [],
    main_header: [],
    records: [],
    total: [],
    employees_ids: [],
    users_ids: [],
    pagination: {},
    currency_type: null,
    status_code: null,
  },
  payrun_all_info: {
    header: [],
    main_header: [],
    records: [],
    total: [],
    employees_ids: [],
    users_ids: [],
    pagination: {},
    currency_type: null,
    status_code: null,
  },
  step: 0,
  confirmedPayrun: {},
  gosiIssuesLoading: false,
  gosiFilesLoading: false,
  gosiIssues: {
    gosi_file_issues: [],
    pagination: {},
  },
  gosiFiles: [],
  indexUpdating: null,
  downloading: null,
  filters: {
    page: 1,
    rpp: 10,
    search: '',
    detail_view: null,
    mol_registration_ids: [],
    area_ids: [],
    department_ids: [],
    business_unit_ids: [],
    location_ids: [],
    outsourcing_company_ids: [],
    grade_ids: [],
    payment_methods: [],
    job_title_ids: [],
    nationalities: [],
    additiondeductionValues: {},
    columns: [
      'base_salary',
      'benefits',
      'total_salary',
      'additions',
      'total_additions',
      'deductions',
      'total_deductions',
      'net_salary',
      'agency_fees',
      'paid_to_employee',
      'paid_to_provider',
      'show_full_name',
    ],
    employment_type_ids: [],
  },
  refresh_step2: false,
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case actions.PAYRUN_CONFIRM_PENDING:
    case actions.PAYRUN_ALL_INFO_LOAD_PENDING:
    case actions.PAYRUN_ADDITIONS_DEDUCTIONS_LOAD_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.PAYRUN_PRINT_REPORT_DOWNLOAD_PENDING:
      return {
        ...state,
        downloading: 'pdf',
      }

    case actions.PAYRUN_EXECL_REPORT_DOWNLOAD_PENDING:
      return {
        ...state,
        downloading: 'xls',
      }

    case actions.PAYRUN_STEPPER: {
      return {
        ...state,
        step: action.payload.step,
      }
    }

    case actions.PAYRUN_ADDITIONS_DEDUCTIONS_LOAD_FULFILLED: {
      return {
        ...state,
        additions_deduction_info: {
          ...action.payload.data.data,
          cellClasses: handlePayrunClasses(action.payload.data.data.main_header),
        },
        fetching: false,
      }
    }

    case actions.PAYRUN_CONFIRM_FULFILLED: {
      return {
        ...state,
        confirmedPayrun: action?.payload?.data?.data?.payrun,
        fetching: false,
      }
    }

    case actions.PAYRUN_ALL_INFO_LOAD_FULFILLED: {
      return {
        ...state,
        payrun_all_info: {
          ...action.payload.data.data,
          cellClasses: handlePayrunClasses(action.payload.data.data.main_header),
        },
        fetching: false,
      }
    }

    case actions.PAYRUN_GOSI_FILE_ISSUES_LOAD_PENDING: {
      return {
        ...state,
        gosiIssuesLoading: true,
      }
    }

    case actions.PAYRUN_GOSI_FILE_ISSUES_LOAD_FULFILLED: {
      const { previous_page } = action.payload.data.data.pagination
      return {
        ...state,
        gosiIssuesLoading: false,
        gosiIssues: {
          gosi_last_updated: action.payload.data.data.gosi_last_updated,
          pagination: action.payload.data.data.pagination,
          gosi_file_issues: [
            ...new Set([
              ...(previous_page ? state.gosiIssues.gosi_file_issues : []),
              ...action.payload.data.data.gosi_file_issues,
            ]),
          ],
        },
      }
    }

    case actions.PAYRUN_GOSI_FILE_ISSUES_LOAD_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        gosiIssuesLoading: false,
      }
    }

    case actions.PAYRUN_GOSI_FILES_LOAD_PENDING: {
      return {
        ...state,
        gosiFilesLoading: true,
        gosiFiles: [],
      }
    }

    case actions.PAYRUN_GOSI_FILES_LOAD_FULFILLED: {
      return {
        ...state,
        gosiFilesLoading: false,
        gosiFiles: action.payload.data.data,
      }
    }

    case actions.PAYRUN_GOSI_FILES_LOAD_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        gosiFilesLoading: false,
        gosiFiles: {},
      }
    }

    case actions.PAYRUN_GOSI_SALARY_UPDATION_PENDING:
    case actions.PAYRUN_GOSI_EMPLOYEE_REGISTRATION_PENDING: {
      const { issueIndex } = action.payload

      return {
        ...state,
        fetching: true,
        indexUpdating: issueIndex,
      }
    }

    case actions.PAYRUN_GOSI_SALARY_UPDATION_FULFILLED:
    case actions.PAYRUN_GOSI_EMPLOYEE_REGISTRATION_FULFILLED: {
      Toastr.success(action.payload.data.message)
      const { indexUpdating } = state

      return {
        ...state,
        gosiIssues: {
          ...state.gosiIssues,
          gosi_file_issues: state.gosiIssues.gosi_file_issues.map((issue, i) =>
            i === indexUpdating ? { ...issue, task_exists: true } : issue,
          ),
        },
        fetching: false,
        indexUpdating: null,
      }
    }
    case actions.UPTO_DATE_GOSI_FILES_PENDING:
    case actions.UPDATE_PAYSLIPS_SCHEDULE_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.UPTO_DATE_GOSI_FILES_FULFILLED:
      return {
        ...state,
        fetching: false,
      }

    case actions.UPDATE_PAYSLIPS_SCHEDULE_FULFILLED: {
      Toastr.success(action.payload.data.message)
      const { payslips_to_be_sent_on } = JSON.parse(action.payload.config.data || '{}')

      return {
        ...state,
        fetching: false,
        confirmedPayrun: {
          ...state.confirmedPayrun,
          payslips_to_be_sent_on,
        },
      }
    }

    case actions.PAYRUN_PRINT_REPORT_DOWNLOAD_FULFILLED:
    case actions.PAYRUN_PRINT_REPORT_DOWNLOAD_REJECTED:
    case actions.PAYRUN_EXECL_REPORT_DOWNLOAD_FULFILLED:
    case actions.PAYRUN_EXECL_REPORT_DOWNLOAD_REJECTED:
      return {
        ...state,
        downloading: null,
      }

    case actions.SET_PAYRUN_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters,
        },
      }

    case actions.REFRESH_STEP_2:
      return {
        ...state,
        refresh_step2: !state.refresh_step2,
      }

    case actions.PAYRUN_CONFIRM_REJECTED:
    case actions.PAYRUN_ALL_INFO_LOAD_REJECTED:
    case actions.PAYRUN_ADDITIONS_DEDUCTIONS_LOAD_REJECTED:
    case actions.PAYRUN_GOSI_SALARY_UPDATION_REJECTED:
    case actions.PAYRUN_GOSI_EMPLOYEE_REGISTRATION_REJECTED:
    case actions.UPTO_DATE_GOSI_FILES_REJECTED:
    case actions.UPDATE_PAYSLIPS_SCHEDULE_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }

    case actions.RESET_PAYRUN: {
      return initialState
    }

    default:
      return state
  }
}
